import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { Iterable1y3qizuf89iou as Iterable } from '../collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArrayish54psvuvyhrq3 as isArrayish,
} from './typeCheckUtils.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from './arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function iterator(_this__u8e3s4) {
  var r = _this__u8e3s4;
  var tmp;
  if (_this__u8e3s4['iterator'] != null) {
    tmp = _this__u8e3s4['iterator']();
  } else if (isArrayish(r)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = arrayIterator(r);
  } else {
    tmp = ((!(r == null) ? isInterface(r, Iterable()) : false) ? r : THROW_CCE()).m1();
  }
  return tmp;
}
//region block: exports
export {
  iterator as iterator2ui8u8e1d2x5o,
};
//endregion

//# sourceMappingURL=dynamic.mjs.map
